import { render, staticRenderFns } from "./SubTitle1.vue?vue&type=template&id=7b38cd80&scoped=true&"
import script from "./SubTitle1.vue?vue&type=script&lang=js&"
export * from "./SubTitle1.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle1.vue?vue&type=style&index=0&id=7b38cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38cd80",
  null
  
)

export default component.exports